import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { initAnalytics, trackPageView } from "../../lib/analytics";

const COOKIE_CONSENT_KEY = "paranoidi_cookie_consent_v1";

export default function CookieConsent() {
  const { t } = useTranslation("common");
  const [isVisible, setIsVisible] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsReady(true);

    const savedConsent = window.localStorage.getItem(COOKIE_CONSENT_KEY);

    if (!savedConsent) {
      setIsVisible(true);
    }
  }, []);

function handleAcceptAll() {
  window.localStorage.setItem(
    COOKIE_CONSENT_KEY,
    JSON.stringify({
      accepted: true,
      analytics: true,
      timestamp: new Date().toISOString(),
    })
  );

  initAnalytics();
  trackPageView(window.location.pathname);

  setIsVisible(false);
}

  function handleNecessaryOnly() {
    window.localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({
        accepted: true,
        analytics: false,
        timestamp: new Date().toISOString(),
      })
    );

    setIsVisible(false);
  }

  if (!isReady || !isVisible) {
    return null;
  }

  return createPortal(
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        padding: "12px",
        pointerEvents: "none",
      }}
    >
      <section
        className="mx-auto max-w-5xl overflow-hidden rounded-3xl border border-red-500/25 bg-zinc-950/95 p-5 text-white shadow-2xl shadow-black/70 backdrop-blur-2xl sm:p-6"
        style={{
          pointerEvents: "auto",
        }}
      >
        <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <div className="max-w-3xl">
            <p className="text-xs font-black uppercase tracking-[0.22em] text-red-300">
              {t("cookies.label")}
            </p>

            <h2 className="mt-2 text-xl font-black tracking-tight sm:text-2xl">
              {t("cookies.title")}
            </h2>

            <p className="mt-2 text-sm leading-6 text-zinc-300">
              {t("cookies.description")}
            </p>
          </div>

          <div className="flex shrink-0 flex-col gap-2 sm:flex-row md:flex-col lg:flex-row">
            <button
              type="button"
              onClick={handleNecessaryOnly}
              className="rounded-full border border-white/15 px-5 py-3 text-xs font-black uppercase tracking-[0.14em] text-zinc-200 transition hover:bg-white/10 hover:text-white"
            >
              {t("cookies.necessaryOnly")}
            </button>

            <button
              type="button"
              onClick={handleAcceptAll}
              className="rounded-full bg-red-500 px-5 py-3 text-xs font-black uppercase tracking-[0.14em] text-white shadow-[0_0_24px_rgba(239,68,68,0.28)] transition hover:bg-red-400"
            >
              {t("cookies.acceptAll")}
            </button>
          </div>
        </div>
      </section>
    </div>,
    document.body
  );
}